import { Controller, useFormContext } from 'react-hook-form'

import type { ImageValue } from '@/components/retail/home-form-model'
import { ShopImageField } from '@/components/retail/shop-image-field'
import { FieldError } from '@/components/ui/field'
import { Label } from '@/components/ui/label'

/** Ô ảnh gắn một trường {url, thumb_url} của form react-hook-form; chọn ảnh
 *  qua thư viện ảnh (MediaPicker), giữ object như hợp đồng §14.20. */
export function HomeImageInput({
    name,
    label,
    hint,
    required,
    className,
}: {
    name: string
    label: string
    hint?: string
    required?: boolean
    className?: string
}) {
    const { control } = useFormContext()
    return (
        <div className="space-y-1.5">
            <Label htmlFor={name} required={required}>
                {label}
            </Label>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <ShopImageField
                        asObject
                        id={name}
                        label={label}
                        value={(field.value as ImageValue | null) ?? null}
                        onChange={field.onChange}
                        className={className}
                    />
                )}
            />
            {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
            <FieldError name={name} />
        </div>
    )
}
